export const WINDOW_KEY: string = '__analyticsQueue';
export const EVENT: EVENT = 'event';
export type EVENT = 'event';
export const PAGE: PAGE = 'page';
export type PAGE = 'page';
export const CONFIG: CONFIG = 'config';
export type CONFIG = 'config';
export const EVENT_LATER: EVENT_LATER = 'event-later';
export type EVENT_LATER = 'event-later';
export const GET_API: GET_API = 'get-api';
export type GET_API = 'get-api';

export type ConsumeTypes = (EVENT | PAGE | CONFIG | EVENT_LATER | GET_API);

export interface ContextConfig {
    'tracking-location'?: string;
    'referrer'?: string;
    'env'?: string;
    'adstatus'?: string;
    'adtypeid'?: string;
    'areaid'?: string;
    'customername'?: string;
    'client.application'?: string;
    'client.device'?: string;
    'deparea'?: string;
    'eventgroups'?: string;
    'finnkode'?: string;
    'loggedIn'?: string;
    'maincat'?: string;
    'objectpostcode'?: string;
    'prodcat'?: string;
    'ref'?: string;
    'currentTimeSinceFas'?: string;
    'currentTimeSinceFrontpage'?: string;
    'timeFasToFinncode'?: string;
    'timeFrontpageToFinncode'?: string;
    'view'?: string;
    'campaign'?: string;
    'internalsearchresults'?: string;
    'searchresultcount'?: string;
    'internalsearchterm'?: string;
    'server'?: string;
    'sessionhash'?: string;
    'site'?: string;
    'platform'?: string;
    'list1'?: string;
    'list2'?: string;
    'list3'?: string;
    'subcat'?: string;
    'subcat3'?: string;
    'submarket'?: string;
    'usergroup'?: string;
    'userid'?: string;
    'orgid'?: string;
    'resultListLayout'?: string;
    'trackinginput'?: string;
    'queryparams'?: string;
    'fullurl'?: string;
    'fullurlnoparams'?: string;
    'pageName'?: string;
    'products'?: string;
    'vertical'?: string;
    'verticalId'?: string;
    'visitorSessionId'?: string;
    'visitorId'?: string;
    'adobeEvents'?: string[],
    'promotion.extendedProfile'?: string;
    'fromdate'?: string;
    'todate'?: string;
    'custmeta'?: string;

    ecType?: string;
    ecCategory?: string;

    'ajsversion'?: string;
}

export interface TrackingConfig {
    navigationStartTime?: string | number;
    mainContentReadyTime?: string | number;

    ecType?: string;
    ecCategory?: string;
    ecData?: any;
    ecPayload?: any;

    context?: ContextConfig;
}

export interface PageTrackingConfig extends TrackingConfig  {
    analyticsName?: string;
    eventFlags?: string;
    eventName?: string; // @deprecated
    kpi?: string;
    eventKpi?: string;
    eventError?: string;
    eventData?: {
        [key: string]: string | undefined,
        ecType?: string,
        ecCategory?: string,
    };

    products?: string[];
    purchaseID?: string;
    numberValue?: number;
    stringValue?: string;

    funnelName?: string;
    funnelStep?: string;
    funnelFlags?: string;

    combine?: boolean;
}

export interface EventTrackingConfig extends PageTrackingConfig {
    analyticsName: string;
}

export type TrackingConsumable = [ConsumeTypes, EventTrackingConfig | PageTrackingConfig | TrackingConfig | ContextConfig | Function];
